import { BaseService } from './base.service';
import { UpdateUserPayload } from '../models/service.models';

export interface NotificationPreferences {
  email_invited_to_team: string;
  email_platform_update: string;
  email_message_board_post: string;
  email_message_board_reply: string;
  push_platform_update: string;
  push_training_uploaded: string;
  push_watch_data_synced: string;
  push_rsvp_update: string;
}

export default class UserService extends BaseService {
  private readonly _userUrl = 'user';

  public async getUser() {
    return this.axios.get(`${this.backendUrl}/${this._userUrl}`);
  }

  public async updateUser(payload: UpdateUserPayload) {
    const formData = new FormData();
    formData.append('email', payload.email);
    formData.append('firstname', payload.firstname);
    formData.append('lastname', payload.lastname);
    formData.append('profileImage', payload.profileImage);
    formData.append('birthday', payload.birthday);
    formData.append('sex', payload.sex);

    return this.axios.put(`${this.backendUrl}/${this._userUrl}`, formData);
  }

  public async updatePassword(password: string, newPassword: string) {
    return this.axios.post(`${this.backendUrl}/update-password`, {
      password,
      newPassword,
    });
  }

  public updateMeasurementSystem(measurementSystem: string) {
    return this.axios.post(`${this.backendUrl}/measurement-system`, { measurementSystem });
  }

  public getRegisteredConnections() {
    return this.axios.get(`${this.backendUrl}/registered-connections`);
  }

  public getNotificationPreferences() {
    return this.axios.get(`${this.backendUrl}/notification-preferences`);
  }

  public setNotificationPreferences(notificationPreferences: NotificationPreferences) {
    return this.axios.post(`${this.backendUrl}/notification-preferences`, notificationPreferences);
  }

  public getHeartRateZones() {
    return this.axios.get(`${this.backendUrl}/heart-rate-zones`);
  }

  public updateHeartRateZones(heartRateZones) {
    return this.axios.post(`${this.backendUrl}/heart-rate-zones`, heartRateZones);
  }

  public getAthleteAttendance(start_date: string, end_date: string) {
    const params = new URLSearchParams({ start_date, end_date }).toString();
    return this.axios.get(`${this.backendUrl}/athlete/attendance?${params}`);
  }
}
